import { render, staticRenderFns } from "./DrawerForm.vue?vue&type=template&id=924cc410&scoped=true&"
import script from "./DrawerForm.vue?vue&type=script&lang=js&"
export * from "./DrawerForm.vue?vue&type=script&lang=js&"
import style0 from "./DrawerForm.vue?vue&type=style&index=0&id=924cc410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924cc410",
  null
  
)

export default component.exports